import api from "./api.ts";

export type AdminSortField = "created_at" | "payment_status" | "subscription_ends_at";
export type AdminSortDir = "asc" | "desc";

export interface AdminUserRow {
  id: number;
  email: string;
  country: string | null;
  role: string;
  created_at: string | null;
  subscription_active: boolean;
  subscription_ends_at: string | null;
  payment_status: string | null;
}

export interface AdminUserList {
  items: AdminUserRow[];
  total: number;
  page: number;
  page_size: number;
}

export async function listUsers(params: {
  page: number;
  pageSize: number;
  sortBy: AdminSortField;
  sortDir: AdminSortDir;
  q: string;
}) {
  const token = localStorage.getItem("token");
  return api.get<AdminUserList>("/admin/users", {
    params: {
      page: params.page,
      page_size: params.pageSize,
      sort_by: params.sortBy,
      sort_dir: params.sortDir,
      q: params.q || undefined,
    },
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}
